//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { v4 as uuidv4 } from 'uuid'
import TopScreen from '~/components/TopScreen.vue'
import QuestionContainer from '~/components/faq/QuestionContainer.vue'
import APIloading from '~/components/common/APILoading.vue'
import APIFailed from '~/components/common/APIFailed.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import { esaEncryptData, esaDecryptData } from '~/plugins/secret'

export default {
  components: {
    TopScreen,
    QuestionContainer,
    APIloading,
    APIFailed,
    FooterTop
  },
  data () {
    return {
      faq: [],
      fetched: false,
      fetchError: false,
      currentPage: 1,
      rows: 0,
      perPage: 10,
      langID: this.$i18n.locale
    }
  },
  async fetch () {
    if (!this.$encrypt) {
      return
    }
    try {
      const that = this
      const uuid = uuidv4().replace(/-/g, '')
      const faqResponse = await fetch(
        `${process.env.APIURL}/website/common/faq/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            key: this.$encrypt(uuid),
            data: esaEncryptData(
              JSON.stringify({
                logical_status: 1,
                date_mode: '', // 检索的时间类型 1.创建时间 2.更新时间
                start_time: '', // 开始时间 string
                end_time: '', // 结束时间 string
                lang_id: this.langID,
                page_size: this.perPage,
                page_num: this.currentPage
              }),
              uuid
            )
          })
        }
      )
        .then(res => res.json())
        .catch(function (e) {})
      const { data, key } = faqResponse
      const preResult = esaDecryptData(data, that.$decrypt(key))
      const posts = JSON.parse(preResult).list
      that.rows = JSON.parse(preResult).total
      // console.log('posts === >', JSON.parse(preResult))
      // console.log('filteredPosts === >', filteredPosts)
      that.fetched = true
      if (posts.length) {
        that.faq = posts
        return
      } else if (that.langID !== 'pt') {
        that.langID = 'pt'
        // eslint-disable-next-line nuxt/no-timing-in-fetch-data
        setTimeout(() => {
          that.clientFetch()
        }, 0)
        return
      }
      that.faq = []
    } catch (err) {
      console.log('err', err)
      this.posts = []
      this.fetched = true
      // this.fetchError = true
    }
  },
  // fetchOnServer: false,
  head () {
    return {
      title: this.$t('faq.top-title').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  watch: {
    currentPage () {
      this.clientFetch()
    }
  },
  mounted () {
    this.clientFetch()
  },
  methods: {
    clientFetch () {
      this.$fetch()
    }
  }
}
